import { DynamicPagination as Pagination } from './Pagination';

export default Pagination;
